/* jshint ignore:start */
/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import FilterService from "@/services/FilterService";

Vue.use(Vuex)
const state = {
    loading: false,
    Branch_List: [],
    Department_List: [],
    Position_List: [],
    Employee_List: [],
    SelectBranch: 'All',
    SelectDepartment: 'All',
    SelectPosition: 'All',
    FromDate: "",
    ToDate: "",
    SearchData: '',
    showFilter: 0,
    Errormsg: ''
}

const getters = {
    getShowFilter: state => {
        return state.showFilter
    },
    getGetSearch: state => {
        return state.SearchData
    },
}

const mutations = {
    setShowFilter(state, {
        status
    }) {
        state.showFilter = status
        console.log(state.showFilter);
    },
    getBranch(state, {
        errorMsg,
        BranchList
    }) {
        state.Branch_List = BranchList
        state.Errormsg = errorMsg

        state.Department_List = []
        state.Position_List = []
        state.Employee_List = []
        state.SearchData = ''
        //console.log(state.Branch_List);
    },
    getDepartment(state, {
        setBranch,
        DepartmentList
    }) {
        state.Department_List = DepartmentList
        state.SelectBranch = setBranch
        state.SelectDepartment = "All"
        state.SelectPosition = "All"
        state.Position_List = []
        state.SearchData = ''
        //console.log(state.Department_List);
    },
    getPosition(state, {
        setDepartment,
        PositionList
    }) {
        state.Position_List = PositionList
        state.SelectDepartment = setDepartment
        state.SearchData = ''
        state.loading = false;

    },
    selectedPosition(state, {
        data
    }) {
        state.SelectPosition = data
        state.SearchData = ''
    },
    selectedSearchData(state, {
        data
    }) {
        state.SearchData = data
    },
    getAllEmployeeByBranch(state, {
        emplist
    }) {
        state.Employee_List = emplist
        state.loading = false

        console.log('state.loading  '+state.loading )
    },
    selectedFormDate(state, {
        data
    }) {
        state.FromDate = data
    },
    selectedToDate(state, {
        data
    }) {
        state.ToDate = data
    },
    setlogout(state) {
        state.loading = false,
            state.Branch_List = [],
            state.Department_List = [],
            state.Position_List = [],
            state.Employee_List = [],
            state.SelectBranch = 'All',
            state.SelectDepartment = 'All',
            state.SelectPosition = 'All',
            state.FromDate = "",
            state.ToDate = "",
            state.SearchData = '',
            state.showFilter = 0,
            state.Errormsg = ''
    }
}

const actions = {
    async getBranch({
        commit,
        dispatch
    }) {

        let error = ''
        let Res_list = [{
            code: "All",
            create_date_time: "",
            guid: "",
            last_update_time: "",
            name: "เลือกสาขา",
            remark: "",
            roworder: ""
        }]
        await FilterService._getBranch()
            .then(res => {
                //console.log(res)
                if (res && res.data != undefined) {
                    res.data.content.forEach(currentItem => {
                        Res_list.push(currentItem);
                    });
                }
            })
            .catch(err => {
                error = err
            })

        await commit("getBranch", {
            errorMsg: error,
            BranchList: Res_list
        })

        await dispatch("getDepartment", {
            "branch": state.SelectBranch
        });
    },

    async getDepartment({
        commit,
        dispatch
    }, {
        branch
    }) {
        state.loading = true;
        let Res_list = [{
            branceCode: "",
            branch_name: "",
            code: "All",
            create_date_time: "",
            guid: "",
            last_update_time: "",
            name: "ทุกฝ่าย",
            remark: "",
            roworder: ""
        }]
        await FilterService._getDepartment(branch)
            .then(res => {
                if (res && res.data != undefined) {
                    res.data.forEach(currentItem => {
                        Res_list.push(currentItem);
                    });
                }
            })
            .catch(err => {
                error = err
            })

        await commit("getDepartment", {
            setBranch: branch,
            DepartmentList: Res_list
        })

        dispatch("getEmployee");

        await dispatch("getPosition", {
            "department": state.SelectDepartment
        });
    },
    async getPosition({
        commit
    }, {
        department
    }) {
        let Res_list = [{
            code: 'All',
            name: 'ทุกตำแหน่ง'
        }]

        await FilterService._getPosition(state.SelectBranch, department)
            .then(res => {
                //console.log(res)
                if (res && res.data != undefined) {
                    res.data.forEach(currentItem => {
                        if (currentItem === "") {
                            currentItem = "ไม่มีตำแหน่ง"
                        }
                        Res_list.push({
                            code: currentItem,
                            name: currentItem
                        });
                    });
                }
            })
            .catch(err => {
                error = err
            })

        await commit("getPosition", {
            setDepartment: department,
            PositionList: Res_list
        })
    },
    async getEmployee({commit},action) {
       
        if(action == undefined){
            action = "newData"
        }
        console.log("action"+action)
        if (state.Employee_List.length == 0 && action =='newData') {
            let Res_list = []
            await FilterService._getAllEmployeeByBranch(state.SelectBranch)
                .then(res => {
                    // console.log(res)
                    if (res && res.data != undefined) {
                        res.data.forEach(data => {
                            Res_list.push({
                                code: data.code,
                                name: data.code + ' - ' + data.first_name + ' ' + data.last_name
                            });
                        });
                    }
                })
                .catch(err => {
                    console.log(err)
                })

            await commit("getAllEmployeeByBranch", {
                emplist: Res_list
            })
        }
        else if (state.Employee_List.length != 0 && action =='refresh') {
            let Res_list = []
            await FilterService._getAllEmployeeByBranch(state.SelectBranch)
                .then(res => {
                    // console.log(res)
                    if (res && res.data != undefined) {
                        res.data.forEach(data => {
                            Res_list.push({
                                code: data.code,
                                name: data.code + ' - ' + data.first_name + ' ' + data.last_name
                            });
                        });
                    }
                })
                .catch(err => {
                    console.log(err)
                })

            await commit("getAllEmployeeByBranch", {
                emplist: Res_list
            })
        }
    },
    async setSearchData({
        commit,
        dispatch
    }, {
        value
    }) {
        await commit("selectedSearchData", {
            data: value
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}